/* eslint-disable prettier/prettier */
<template>
  <button
    class="btn mb-0 text-white"
    :disabled="disabled"
    :class="getClasses(variant, color, size, fullWidth, active)"
  >
    <div v-if="loading" class="spinner-border" role="status">
      <span class="visually-hidden">جارٍ التحميل...</span>
    </div>
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: 'ArgonButton',
  props: {
    color: {
      type: String,
      default: 'main-dark',
    },
    size: {
      type: String,
      default: 'md',
    },
    variant: {
      type: String,
      default: 'fill',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active) => {
      let colorValue, sizeValue, fullWidthValue, activeValue;

      // Setting the button variant and color
      if (variant === 'gradient') {
        colorValue = `bg-gradient-${color}`;
      } else if (variant === 'outline') {
        colorValue = `btn-outline-${color}`;
      } else {
        colorValue = `btn-${color}`;
      }

      sizeValue = size ? `btn-${size}` : '';

      fullWidthValue = fullWidth ? `w-100` : '';

      activeValue = active ? `active` : '';

      return `${colorValue} ${sizeValue} ${fullWidthValue} ${activeValue}`;
    },
  },
};
</script>
